"use client";

import { Link } from "@/i18n/navigation";
import { useTranslations } from "next-intl";
import SolarIcon from "@/components/ui/SolarIcon/SolarIcon";

export default function Mentor({ mentor }) {
    const t = useTranslations();
    return (
        <Link
            href={{ pathname: "/mentoring/[pseudo]", params: { pseudo: mentor.mentorPseudo || `believer-${mentor.id}` } }}
            className="group block"
        >
            <div className="relative aspect-[3/4] rounded-2xl overflow-hidden shadow-sm transition-shadow duration-300 group-hover:shadow-xl">
                {/* Portrait (léger zoom au survol) */}
                <div
                    className="absolute inset-0 bg-cover bg-top transition-transform duration-[600ms] ease-out group-hover:scale-105"
                    style={{ backgroundImage: `url(${mentor.mentorPicture})` }}
                />

                {/* Dégradé bas */}
                <div
                    className="absolute inset-0"
                    style={{
                        background:
                            "linear-gradient(to top, rgba(0,0,0,0.9), rgba(0,0,0,0.12) 52%, rgba(0,0,0,0) 80%)",
                    }}
                />

                {/* Contenu */}
                <div className="absolute inset-x-0 bottom-0 p-5">
                    <h3 className="text-white text-lg font-semibold leading-tight tracking-tight">
                        {mentor.firstName} {mentor.lastName}
                    </h3>
                    {mentor.mentorBio && (
                        <p className="mt-1 text-[13px] text-white/70 leading-snug line-clamp-2">
                            {mentor.mentorBio}
                        </p>
                    )}

                    {/* Tarif. Si le mentor offre un premier appel découverte,
                        on barre le tarif et on met un macaron pour inciter à
                        s'inscrire (le prix seul décourage). */}
                    {mentor.pricePerCall &&
                        (mentor.mentorAllowsFreeDiscoveryCall ? (
                            <div className="mt-2.5">
                                <p className="mb-0 text-sm font-medium text-white/90">
                                    {t("mentor_discovery_offered")}{" "}
                                    <span className="font-normal text-white/45 line-through">
                                        {mentor.pricePerCall} €
                                    </span>
                                </p>
                                <span className="mt-2 inline-flex items-center gap-1.5 rounded-full bg-white/10 backdrop-blur-sm px-2.5 py-1 text-[11px] font-semibold text-white">
                                    <SolarIcon
                                        name="gift-linear"
                                        className="text-xs text-primary"
                                    />
                                    {t("GuestBooking_free")}
                                </span>
                            </div>
                        ) : (
                            <p className="mt-2.5 text-sm font-medium text-white/90">
                                {mentor.pricePerCall} €
                            </p>
                        ))}
                </div>
            </div>
        </Link>
    );
}
